/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function ColumnTypeSelect({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g fill="currentColor" clipPath="url(#ColumnTypeSelect_svg__a)"><path d="M4.946 6.77A.6.6 0 0 1 5.5 6.4h5a.6.6 0 0 1 .424 1.024l-2.5 2.5a.6.6 0 0 1-.848 0l-2.5-2.5a.6.6 0 0 1-.13-.654Z" /><path fillRule="evenodd" d="M3.5.9A2.6 2.6 0 0 0 .9 3.5v9a2.6 2.6 0 0 0 2.6 2.6h9a2.6 2.6 0 0 0 2.6-2.6v-9A2.6 2.6 0 0 0 12.5.9h-9ZM2.1 3.5a1.4 1.4 0 0 1 1.4-1.4h9a1.4 1.4 0 0 1 1.4 1.4v9a1.4 1.4 0 0 1-1.4 1.4h-9a1.4 1.4 0 0 1-1.4-1.4v-9Z" clipRule="evenodd" /></g><defs><clipPath id="ColumnTypeSelect_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;